
  import { Component, Vue } from 'vue-property-decorator';
  import PageFooter from '@/components/page-footer.vue';
	import CollapseItem from '@/components/collapse.vue';
  import uploadImg from "@/components/upload-img.vue"
  import chooseCoupon from "@/components/chooseCoupon.vue"
  import {
    nextDay
  } from "@/utils"
  import {
    activityDailyCheckactivityDailyCheckInfo,
    activityDailyCheckactivityDailyCheckSave
  } from "@/api/live"
  @Component({  
    name: '',
    components: {
      PageFooter,
      CollapseItem,
      uploadImg,
      chooseCoupon
    }
  })

  export default class ProductList extends Vue {
    private loading = false
    private form:any = {
      Id:0,
      ActivityState:0,
      ActivityName:'',
      ActivityStartTime:'',
      ActivityEndTime:'',
      ActivityInstruction:'',
      JoinObject:[1,2],
      TimeLimitType:0,
      StartTime:'',
      EndTime:'',
      ValidTime:'',
      ValidTime2:'',
      DayCheckPrizeList:[],
      EmptyPrizeCardIsDistinguishDate:false,
      EmptyPrizeCardList:[],
      EmptyPrizeCardImgUrlList:[],
      ContinuCheckPrizeList:[],
      ShareContent:'',
      ShareImgUrl:[],
      UseRuleInstruction: ''
    }
    private EmptyPrizeCardList:any = []
    private total = 0
    private pageNo = 1
    private pageSize = 10
    private showEmptyPrize = true
    private typelist = [
      {value:1,label:'红包'},
      {value:2,label:'优惠券'},
    ]
    private chooseShow = false
    private choosedata:any = []
    private couponIndex = 0
    private options = {
      disabledDate:(e)=>{
        return new Date(e).getTime() < new Date().getTime()-1000*60*60*24
      }
    }

    private mounted () {
      if(Number(this.$route.query.Id)>0){
        this.getInfo()
      }
    }

    private async getInfo(){
      this.loading = true
      try{
        let res = await activityDailyCheckactivityDailyCheckInfo({
          Id:this.$route.query.Id
        })
        if(res.IsSuccess){
          let form = res.Result
          form.ValidTime2 = ''
          if(form.TimeLimitType==2){
            form.ValidTime2 = form.ValidTime
            form.ValidTime = ''
          }
          if(form.TimeLimitType!=1){
            form.ValidTime = ''
          }
          form.ShareImgUrl = [form.ShareImgUrl]
          this.form = JSON.parse(JSON.stringify(form))
          this.getTime()
        }
      }finally{
        this.loading = false
      }
    }
    private check(){
      let form = JSON.parse(JSON.stringify(this.form))
      if(!form.ActivityName){
        this.$message.error('请输入活动名称')
        return false
      }
      if(!form.ActivityStartTime||!form.ActivityEndTime){
        this.$message.error('请完善活动时间')
        return false
      }
      if(new Date(form.ActivityStartTime).getTime() > new Date(form.ActivityEndTime).getTime()){
        this.$message.error('开始时间不能晚于结束时间')
        return false
      }
      if(!form.ActivityInstruction){
        this.$message.error('请填写活动说明，方便用户更好了解活动细则')
        return false
      }
      if(!form.JoinObject||!form.JoinObject.length){
        this.$message.error('请设置参与对象')
        return false
      }
      if(form.TimeLimitType==0){
        if(!form.StartTime||!form.EndTime){
          this.$message.error('请完善红包使用时间')
          return false
        }
        if(new Date(this.form.StartTime).getTime() > new Date(this.form.EndTime).getTime()){
          this.$message.error('开始时间不能晚于结束时间')
          return false
        }
      }else if(form.TimeLimitType==1){
        if(form.ValidTime<1||form.ValidTime>9999){
          this.$message.error('使用期限允许1~9999天')
          return false
        }
      }else if(form.TimeLimitType==2){
        if(form.ValidTime2<1||form.ValidTime2>9999){
          this.$message.error('使用期限允许1~9999天')
          return false
        }
      }
      let two = /^\d+(\.\d{1,2})?$/
      let one = /^\d+(\.\d{1,1})?$/
      let allChance = 0
      for(let item of form.DayCheckPrizeList){
        if(Number(item.RedpacketMoney)<0.01||Number(item.RedpacketMoney)>999.99||!two.test(item.RedpacketMoney)){
          this.$message.error('红包金额限制0.01~999.99')
          return false
        }
        if(item.RedpacketCount<1||item.RedpacketCount>999999){
          this.$message.error('红包个数允许1~999999')
          return false
        }
        if(item.PrizeOdds<0||item.PrizeOdds>100||!one.test(item.PrizeOdds)){
          this.$message.error('概率允许输入0~100的数值，最多1位小数')
          return false
        }
        allChance+=Number(item.PrizeOdds)
      }
      if(allChance>100){
        this.$message.error('奖励概率之和大于100%，请修改')
        return false
      }
      if(!form.EmptyPrizeCardIsDistinguishDate){
        if(!form.EmptyPrizeCardImgUrlList||!form.EmptyPrizeCardImgUrlList.length){
          this.$message.error('请上传空奖卡片图')
          return false
        }
      }else{
        for(let item of form.EmptyPrizeCardList){
          if(!item.ImgUrlList||!item.ImgUrlList.length){
            this.$message.error('请上传空奖卡片图')
            return false
          }
        }
      }
      for(let item of form.ContinuCheckPrizeList){
        if(item.ContinuDays<1||item.ContinuDays>365){
          this.$message.error('连签天数允许1~365天')
          return false
        }
        if(item.PrizeType==1){
          if(Number(item.RedpacketMoney)<0.01||Number(item.RedpacketMoney)>999.99||!two.test(item.RedpacketMoney)){
            this.$message.error('红包金额限制0.01~999.99')
            return false
          }
        }else{
          if(!item.PrizeRelationId){
            this.$message.error('请选择优惠券')
            return false
          }
        }
      }
      let days = Array.from(new Set(form.ContinuCheckPrizeList.map(v=>v.ContinuDays)))
      // console.log(days)
      if(days.length!=form.ContinuCheckPrizeList.length){
        this.$message.error('连签天数重复设置')
        return false
      }
      if(!form.ShareContent){
        this.$message.error('请设置分享文案')
        return false
      }
      if(!form.ShareImgUrl||!form.ShareImgUrl.length){
        this.$message.error('请上传分享图片')
        return false
      }
      return true
    }
    private async save(){
      if(!this.check()) return
      let form = JSON.parse(JSON.stringify(this.form))
      if(form.TimeLimitType==0){
        form.ValidTime = ''
      }else{
        form.StartTime = ''
        form.EndTime = ''
        form.ValidTime = form.TimeLimitType==1?form.ValidTime:form.ValidTime2
      }
      if(form.EmptyPrizeCardIsDistinguishDate){
        form.EmptyPrizeCardImgUrlList = []
        form.EmptyPrizeCardList = form.EmptyPrizeCardList.map((v,i)=>{
          v.Sort = i+1
          return v
        })
      }else{
        form.EmptyPrizeCardList = []
      }
      form.ContinuCheckPrizeList = form.ContinuCheckPrizeList.map((v,i)=>{
        if(v.PrizeType==1){
          v.PrizeRelationId = ''
          v.PrizeRelationName = ''
        }else{
          v.RedpacketMoney = ''
        }
        v.Sort = i+1
        return v
      })
      form.DayCheckPrizeList = form.DayCheckPrizeList.map((v,i)=>{
        v.Sort = i+1
        return v
      })
      form.ShareImgUrl = form.ShareImgUrl[0]

      try{
        this.loading = true
        let res = await activityDailyCheckactivityDailyCheckSave(form)
        if(res.IsSuccess){
          this.$message.success('保存成功')
          this.$router.go(-1)
        }
      }finally{
        this.loading = false
      }
    }
    private getData(list){
      if(!list||!list.length){
        this.$message.error('请选择优惠券')
        return
      }
      this.form.ContinuCheckPrizeList[this.couponIndex].PrizeRelationId = list[0].Id
      this.form.ContinuCheckPrizeList[this.couponIndex].PrizeRelationName = list[0].CouponName
      this.chooseShow = false
    }
    private setcoupon(v,i){
      this.chooseShow = true
      this.couponIndex = i
      this.choosedata = []
      if(v.PrizeRelationId){
        this.choosedata = [{
          Id:v.PrizeRelationId,
          CouponName:v.PrizeRelationName
        }]
      }
    }
    private addcontinuous(){
      if(this.form.ContinuCheckPrizeList.length>=30){
        this.$message.error('最多添加30个连签奖励')
        return
      }
      this.form.ContinuCheckPrizeList.push({
        Id:0,
        ContinuDays:'',
        PrizeType:1,
        RedpacketMoney:'',
        PrizeRelationName:'',
        PrizeRelationId:'',
        SendCount:'',
        Sort:0
      })
    }
    private getTime(){
      if(this.form.ActivityStartTime&&this.form.ActivityEndTime){
        let days = Math.floor((new Date(this.form.ActivityEndTime).getTime() - new Date(this.form.ActivityStartTime).getTime())/1000/60/60/24+1)
        if(days<1){
          this.$message.error('开始时间不能晚于结束时间')
          return
        }
        let oldlist = JSON.parse(JSON.stringify(this.form.EmptyPrizeCardList))
        this.form.EmptyPrizeCardList = []
        for(let i = 0;i < days; i++){
          let date = new Date(new Date(this.form.ActivityStartTime).getTime() + i * 1000 * 60 * 60 * 24)
          let mon = date.getMonth()+1
          let day = date.getDate()
          let year = date.getFullYear()
          let item:any = {
            Id:0,
            ShowTime:mon+'月'+day+'日',
            ImgUrlList:[],
            key:i,
            Sort:i+1,
            StartTime:year + '-' + (mon>=10?mon:('0'+mon)) + '-' + (day>=10?day:('0'+day)) + ' 00:00:00',
            EndTime:year + '-' + (mon>=10?mon:('0'+mon)) + '-' + (day>=10?day:('0'+day)) + ' 00:00:00',
          }
          // item.EndTime = nextDay(item.StartTime,1)
          let msg = oldlist.find(v=>new Date(v.StartTime).getTime()==new Date(item.StartTime).getTime())
            // console.log(msg)
          if(msg){
            item.ImgUrlList = msg.ImgUrlList
            item.Id = msg.Id
          }
          this.form.EmptyPrizeCardList.push(item)
        }
        this.pageNo = 1
        this.adjustment()
      }
    }
    private adjustment(){
      this.total = this.form.EmptyPrizeCardList.length
      this.EmptyPrizeCardList = this.form.EmptyPrizeCardList.filter((v,i)=>{
        return i >= (this.pageNo-1)*this.pageSize && i < this.pageNo*this.pageSize
      })
      if((!this.EmptyPrizeCardList||!this.EmptyPrizeCardList.length)&&this.pageNo>1){
        this.adjustment()
      }
    }
    private changeCurrent(e){
      this.pageNo = e
      this.adjustment()
    }
    private uploadSuc(list,key){
      this.form[key] = list
    }
    private uploadSuc2(list,v,i){
      this.form.EmptyPrizeCardList.map(x=>{
        if(x.key==v.key){
          x.ImgUrlList = list
        }
      })
      this.adjustment()
    }
    private del(i,key){
      this.form[key].splice(i,1)
    }
    private addaward(){
      if(this.form.DayCheckPrizeList.length>=30){
        this.$message.error('最多添加30个日签奖励')
        return
      }
      this.form.DayCheckPrizeList.push({
        Id:0,
        RedpacketMoney:'',
        RedpacketCount:'',
        PrizeOdds:'',
        SendRedpacketCount:'',
        UseRuleInstruction: '',
        Sort:0,
      })
    }
    private togoal(name){
      const element:any = document.querySelectorAll(`.${name}`)[0]
      element.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      })
    }
  }
